<template>
  <div class="sp-replace-rate">
    <div>
      <span style="border-right:1px solid blue;width:20%" class="trend-title">备件名称</span>
      <span style="border-right:1px solid blue;width:10%" class="trend-title">行业平均更换率</span>
      <span style="width:10%" class="trend-title">实际更换率</span>
      <!-- <el-button @click="addRates" size="small" type="success" icon="el-icon-plus"></el-button> -->
      <i @click="addRates" class="el-icon el-icon-circle-plus-outline f_green"></i>
    </div>
    <div class="replace-rate" v-for="(item,index) in ratesDate" :key="index">
      <el-input show-word-limit type="text" maxlength="20" placeholder="请输入" v-model="item.spareName"></el-input>
      <el-input type="number" v-model="item.tradeReplace">
        <template slot="suffix">%</template>
      </el-input>
      <el-input type="number" v-model="item.onReplace">
        <template slot="suffix">%</template>
      </el-input>
      <i @click="removeRates(item.id,index)" class="el-icon el-icon-remove-outline f_red"></i>
      <!-- <el-button @click="removeRates(item.id,index)" size="small" type="danger" icon="el-icon-minus"></el-button> -->
    </div>
    <div class="last-save">
      <el-button :loading="replaceLoading" size="small" @click="saveReplace" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/apis/device/device'
export default {
  data(){
    return{
      replaceLoading:false,//加载状态
      ratesDate:[
        {spareName:'',tradeReplace:'',onReplace:''}
      ]
    }

  },
  mounted(){
    this.getReplace()
  },
  methods:{
    //保存更换率
    saveReplace(){
      this.replaceLoading = true;
      api.saveSpare(this.ratesDate).then(res=>{
        if(res.code==10000){
          this.replaceLoading = false;
          this.getReplace()
          this.$message.success('保存成功');
        }else{
          this.$message.error(res.message);
          this.replaceLoading = false;
          return;
        }
      })
    },
    //获取更换率
    getReplace(){
      api.getSpare().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.ratesDate = res.data.list
          }
        }
      })
    },
    //删除更换率
    removeRates(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delSpare([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getReplace()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.ratesDate.splice(index,1)
      }
    },

    //增加一行更换率
    addRates(){
      this.ratesDate.push({spareName:'',tradeReplace:'',onReplace:''})
    },
  }
}
</script>
<style lang="less" scoped>
.sp-replace-rate{ padding-top: 10px;
  .trend-title{ text-align: center;}
  i{ font-size: 1rem; line-height: 1.8rem; margin-left: .6rem;}
  .replace-rate{ position: relative; top: -2px;
    .el-input:nth-child(1){ width: 20%;}
    .el-input:nth-child(2){ width: 10%;}
    .el-input:nth-child(3){ width: 10%;}
  }
  .replace-rate:nth-child(3){ top: -5px;;}
}
</style>